export default {
  state: {
    mostrarSucessoModal: false,
    subtituloSucessoModal: "",
    callbackAbrirSucesso: null,
    callbackFecharSucesso: null
  },
  mutations: {
    setMostrarSucessoModal(state, _mostrar) {
      state.mostrarSucessoModal = _mostrar;
      if (_mostrar && state.callbackAbrirSucesso !== null) {
        state.callbackAbrirSucesso();
      } else if (!_mostrar && state.callbackFecharSucesso !== null) {
        state.callbackFecharSucesso();
      }
    },
    setSubtituloSucesso(state, _subtitulo) {
      state.subtituloSucessoModal = _subtitulo;
    },
    setCallbackAbrirSucesso(state, _callback) {
      state.callbackAbrirSucesso = _callback;
    },
    setCallbackFecharSucesso(state, _callback) {
      state.callbackFecharSucesso = _callback;
    },
    setLimparCallbacksSucesso(state) {
      state.callbackAbrirSucesso = null;
      state.callbackFecharSucesso = null;
    }
  },
  getters: {
    getMostrarSucessoModal: state => state.mostrarSucessoModal,
    getSubtituloSucesso: state => state.subtituloSucessoModal
  }
};
